const pickValue = (...values: Array<string | undefined>) => {
  for (const value of values) {
    if (typeof value === 'string' && value.trim().length > 0) {
      return value.trim();
    }
  }
  return '';
};

export const SITE_CONFIG = {
  serviceName: pickValue(import.meta.env.VITE_SITE_NAME, '묘안 타로'),
  serviceNameEn: pickValue(import.meta.env.VITE_SITE_NAME_EN, 'Myoan Tarot'),
  serviceUrl: pickValue(import.meta.env.VITE_SITE_URL, 'https://myoan.bamlab.kr'),
  archiveLabel: pickValue(import.meta.env.VITE_SITE_ARCHIVE_LABEL, '묘안 아카이브'),
  archiveLabelEn: pickValue(import.meta.env.VITE_SITE_ARCHIVE_LABEL_EN, 'Myoan Archive'),
  tagline: pickValue(import.meta.env.VITE_SITE_TAGLINE, '조용히 흐름을 읽는 AI 타로 리딩'),
  shortIntro: pickValue(
    import.meta.env.VITE_SITE_SHORT_INTRO,
    '묘안은 질문을 조용히 읽고, 카드의 흐름으로 지금의 결을 짚어드립니다.',
  ),
} as const;
